<template>
  <div v-if="show" class="traffic-filter-panel">
    <!-- Header -->
    <div class="filter-panel-header">
      <h4 class="filter-panel-title">Traffic</h4>
      <div class="header-actions">
        <ThemedButton variant="ghost" size="icon" @click="$emit('close')" aria-label="Close filters">
          <ThemeIcon icon="x" type="icons" classes="w-5 h-5" />
        </ThemedButton>
      </div>
    </div>
    
    <!-- Traffic Type Selection -->
    <div class="filter-group">
      <label class="filter-label">Traffic Type</label>
      <div class="traffic-type-buttons">
        <ThemedButton
          variant="outline"
          @click="selectTrafficType('live')"
          :class="{ active: localFilters.trafficType === 'live' }"
          class="traffic-type-button"
        >
          <ThemeIcon icon="lightning" type="icons" classes="w-4 h-4 mr-2" />
          Live Traffic
        </ThemedButton>
        <ThemedButton
          variant="outline"
          @click="selectTrafficType('typical')"
          :class="{ active: localFilters.trafficType === 'typical' }"
          class="traffic-type-button"
        >
          <ThemeIcon icon="clock" type="icons" classes="w-4 h-4 mr-2" />
          Typical Traffic
        </ThemedButton>
      </div>
    </div>
    
    <!-- Typical Traffic Notice -->
    <div v-if="localFilters.trafficType === 'typical'" class="typical-traffic-notice">
      <ThemeIcon icon="info-icon" type="icons" classes="w-5 h-5 notice-icon" />
      <div class="notice-content">
        <p class="notice-title">Live Traffic Only</p>
        <p class="notice-text">Google Maps currently only provides live traffic data. The day and time selectors below are for reference but do not affect the traffic display.</p>
      </div>
    </div>

    <div v-if="localFilters.trafficType === 'live'">
      <div class="traffic-legend">
      <div class="legend-item">
        <div class="legend-color fast"></div>
        <span>Fast</span>
      </div>
      <div class="legend-item">
        <div class="legend-color medium"></div>
        <span>Medium</span>
      </div>
      <div class="legend-item">
        <div class="legend-color slow"></div>
        <span>Slow</span>
      </div>
      <div class="legend-item">
        <div class="legend-color very-slow"></div>
        <span>Very Slow</span>
      </div>
    </div>
    </div>
    
    <!-- Typical Traffic Time Selection (only shown when typical is selected) -->
    <!-- <div v-if="localFilters.trafficType === 'typical'" class="filter-group"> -->
      <!-- <label class="filter-label">Day & Time (Reference Only)</label>
      
      <div class="day-selector">
        <button
          v-for="day in daysOfWeek"
          :key="day.value"
          type="button"
          @click="selectDay(day.value)"
          :class="{ active: localFilters.dayOfWeek === day.value }"
          class="day-button"
        >
          {{ day.label }}
        </button>
      </div> -->
      
      <!-- Time Slider -->
      <!-- <div class="time-slider-container">
        <div class="time-slider-header">
          <span class="time-label">{{ formattedTime }}</span>
          <span class="speed-indicator">
            <span class="speed-label">Fast</span>
            <div class="speed-bar">
              <div class="speed-segment fast"></div>
              <div class="speed-segment medium"></div>
              <div class="speed-segment slow"></div>
              <div class="speed-segment very-slow"></div>
            </div>
            <span class="speed-label">Slow</span>
          </span>
        </div>
        <input
          type="range"
          v-model="localFilters.timeOfDay"
          min="0"
          max="23"
          step="1"
          class="time-slider"
          @input="emitFilters"
        />
        <div class="time-markers">
          <span>8:00 AM</span>
          <span>12:00 PM</span>
          <span>4:00 PM</span>
          <span>8:00 PM</span>
        </div>
      </div>
    </div> -->
    
    <!-- Traffic Legend -->
    
  </div>
</template>

<script>
import ThemeIcon from '../ThemeIcon.vue';
import ThemedButton from '../ThemedButton.vue';

export default {
  name: 'TrafficFilterPanel',
  
  components: {
    ThemeIcon,
    ThemedButton
  },
  
  props: {
    filters: {
      type: Object,
      required: true,
      default: () => ({
        trafficType: 'live',
        dayOfWeek: 1, // Monday
        timeOfDay: 9 // 9:00 AM
      })
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      localFilters: {
        trafficType: 'live',
        dayOfWeek: 1,
        timeOfDay: 9
      },
      daysOfWeek: [
        { label: 'S', value: 0 }, // Sunday
        { label: 'M', value: 1 }, // Monday
        { label: 'T', value: 2 }, // Tuesday
        { label: 'W', value: 3 }, // Wednesday
        { label: 'T', value: 4 }, // Thursday
        { label: 'F', value: 5 }, // Friday
        { label: 'S', value: 6 }  // Saturday
      ]
    };
  },
  
  computed: {
    /**
     * Format time of day for display
     */
    formattedTime() {
      const hour = parseInt(this.localFilters.timeOfDay);
      const period = hour >= 12 ? 'PM' : 'AM';
      const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
      return `${displayHour}:00 ${period}`;
    }
  },
  
  watch: {
    filters: {
      handler(newFilters) {
        this.localFilters = {
          trafficType: newFilters.trafficType || 'live',
          dayOfWeek: newFilters.dayOfWeek !== undefined ? newFilters.dayOfWeek : 1,
          timeOfDay: newFilters.timeOfDay !== undefined ? newFilters.timeOfDay : 9
        };
      },
      deep: true,
      immediate: true
    }
  },
  
  methods: {
    /**
     * Select traffic type (live or typical)
     */
    selectTrafficType(type) {
      this.localFilters.trafficType = type;
      this.emitFilters();
    },
    
    /**
     * Select day of week
     */
    selectDay(day) {
      this.localFilters.dayOfWeek = day;
      this.emitFilters();
    },
    
    /**
     * Emit filter changes to parent component
     */
    emitFilters() {
      this.$emit('update:filters', { ...this.localFilters });
    }
  }
};
</script>
